var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"camera-image-list"},_vm._l((_vm.images),function(image){return _c('CameraImage',{key:_vm.getID(),attrs:{"data":image,"container-class":"image-class"},on:{"onRemove":_vm.onImageRemoved}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }